import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AdaCustomization, AdaCustomizationsService, ListComponent, PopUpService } from 'core/index';

@Component({
  selector: 'lms-customizations-list',
  templateUrl: './customizations-list.component.html',
  styleUrls: ['./customizations-list.component.scss']
})
export class CustomizationsListComponent implements OnInit {
  @Input() listId: string;
  @Input() options: any;
  public listOptions: any = { sort: 'name' };
  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  customizations: AdaCustomization[];

  constructor(
    public AdaCustomizationsService: AdaCustomizationsService,
    public router: Router,
    public translate: TranslateService,
    private popupService: PopUpService
  ) {}

  ngOnInit() {
    Object.assign(this.listOptions, this.options);
  }

  setCollection(collection) {
    this.customizations = collection;
  }

  delete(customization: AdaCustomization) {
    this.popupService
      .confirmDelete({
        title: this.translate.instant('customizations.confirmDelete', {
          email: customization.name
        }),
        confirmButtonText: this.translate.instant('actions.delete')
      })
      .then(() => this.AdaCustomizationsService.delete(customization.id))
      .then(() => this.listComponent.fetch())
      .catch((err) => {
        if (err !== 'cancel') {
          this.popupService.showError({
            title: this.translate.instant('customizations.deleteError', {
              name: customization.name
            }),
            text: err.serverMessage
          });
        }
      });
  }
}
